import React, { useLayoutEffect, useState } from "react";
import { navIconArray, logo, navActiveCss, navHoverCss } from "../../constants/NavbarConstants";
import { NavLink, Link, ScrollRestoration, useLocation } from "react-router-dom";
import NavigationConfirmModal from "./NavigationConfirmModal";
import { useSelector } from "react-redux";

const Navbar = ({ active, blocker = null }) => {
  const location = useLocation();
  const isDetailPage =
  location.pathname.startsWith("/church/") ||
  location.pathname.startsWith("/ministry/") ||
  location.pathname.startsWith("/channel/");

  const isRouteActive = (item) => {
    const path = location.pathname;
  
    if (path === item.route) return true;
  
    if (item.route === "/churches" && path.startsWith("/church/")) return true;
    if (item.route === "/ministry" && path.startsWith("/ministry/")) return true;
    if (item.route === "/channels" && path.startsWith("/channel/")) return true;
  
    return false;
  };
  
  
  
  const { currentLanguageTitles } = useSelector((state) => state.languageReducer.data);
  const [showName, setShowName] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(true);
  const handleMouseEnter = (index) => {
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const onMouseOver = () => {
    setShowName(true);
  };

  const onMouseOut = () => {
    setShowName(false);
  };

  const toggleMenu = () => {
    setMenuOpen((prevMenuOpen) => !prevMenuOpen);
  };

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);


  return (
    <>
      <NavigationConfirmModal blocker={blocker} />
      <div
        className="md:flex hidden fixed left-0 top-0 bg-black h-[100vh] flex-col z-50 transition-all duration-300 border-r border-neutral-900 overflow-y-auto overflow-x-hidden navbar-sidebar-container"
        style={{ width: showName ? "280px" : "104px" }}
        onMouseEnter={() => setShowName(true)}
        onMouseLeave={() => setShowName(false)}
      >
        <Link to="/" className="flex justify-center py-6 mt-2 shrink-0">
          <img
            className="cursor-pointer w-[60px]"
            src={logo}
            alt="Logo"
          />
        </Link>
        <ul className="flex flex-col flex-1 gap-1.5 px-4 pb-10 navbar-main relative">
          {navIconArray.map((item, i) => {
            const isActive = isRouteActive(item) || (!isDetailPage && active === item.title);
            return (
              <li className="w-full shrink-0" key={"navitem" + i}>
                <NavLink
                  to={item.route}
                  className={`flex items-center rounded-xl py-2.5 px-3 transition-all duration-200 group ${
                    isActive
                      ? "text-[#F8BA34] bg-neutral-900 font-bold"
                      : "text-white opacity-60 hover:opacity-100 hover:bg-neutral-900"
                  }`}
                >
                  <div className="w-[48px] flex justify-center items-center shrink-0">
                    <img
                      className="nav-icons cursor-pointer h-[24px] w-[24px] object-contain"
                      src={isActive ? item.hover : item.icon}
                      alt={item.title}
                    />
                  </div>
                  <span
                    className={`text-sm tracking-wide ml-2 transition-all duration-300 font-semibold truncate ${
                      showName ? "opacity-100 max-w-[200px]" : "opacity-0 max-w-0 overflow-hidden"
                    } ${isActive ? "text-[#F8BA34]" : "text-white"}`}
                  >
                    {item.title}
                  </span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
      <nav className="MOBILE-NAV md:hidden flex items-center justify-between bg-blackish shadow-lg sticky top-0 p-4 z-[10000] w-full">
        <div className="flex items-center justify-between w-full">
          <div
            className={`hamburger-icon cursor-pointer ${menuOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>

          <Link className="text-white ml-4 font-bold" to={"/login"}>
            <img className="h-12 w-12 object-contain cursor-pointer" src={logo} alt="" />
          </Link>
        </div>

        <div
          onMouseOver={() => setHovered(true)}
          className={`mobile-menu ${menuOpen ? "open" : ""}`}
        >
          <p className="text-lg text-greyish mt-4 mb-4 text-center">Menus</p>
          <ul className="ICON-DIV flex flex-col items-center gap-8">
            {navIconArray.map((item, i) => (
              <NavLink
                key={i}
                to={item.route}
                className={({ isActive, isPending }) =>
                  isPending ? "" : isActive ? `${navActiveCss} h-10 ` : `${navHoverCss} h-10 `
                }
              >
                <li className="relative cursor-pointer p-2 flex flex-col justify-center">
                  <img src={item.icon} alt="menu icon" className="h-8 object-contain" />
                  <p
                    key={i}
                    className="nav-titles z-50 cursor-pointer font-semibold text-white opacity-50 "
                  >
                    {currentLanguageTitles?.[0]?.menus?.[item.key] ?? item.title}
                  </p>
                </li>
              </NavLink>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
